<template src="@/components/RealCards.html">
</template>

<script>
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import Datepicker from 'vuejs-datepicker'

import { getTopPosition, phoneValid, textFieldValid } from '@/utils.js'
import { apiUrl } from '@/config.js'
import ContentLayout from '@/components/ContentLayout.vue'
import MaskedInput from 'vue-masked-input'
import AddressSuggestions from '@/components/Ui/AddressSuggestions'
require('smoothscroll-polyfill').polyfill()

const now = new Date()
const today = {
  day: now.getDate(),
  month: now.getMonth() + 1,
  year: now.getFullYear()
}

export default {
  name: 'real-cards',
  mixins: [validationMixin],
  data () {
    return {
      isMobile: false,
      pending: false,
      cityId: '',
      cities: [],
      cardsByCity: {},
      result: {},
      sendReceiptBySms: false,
      oldOrder: {},
      showPostCards: false,
      specials: [],
      postcard: {
        id: '',
        qty: 0,
        text: '',
        cost: 0
      },
      buyer: {
        name: '',
        email: '',
        phone: ''
      },
      recipient: {
        name: '',
        phone: ''
      },
      delivery: {
        toBuyer: false,
        date: '',
        address: '',
        addressApartment: '',
        cost: 0
      },
      localLoading: false,
      minDate: `${today.year}-${today.month.length === 2 ? today.month : '0' + today.month}-${today.day}`,
      deliveryLimit: 150,
      lowDeliveryLimit: 35,
      incorrectFreeAmount: null,
      deliveryOn: true,
      openCardAmount: 0,
      addressIsCorrect: true,
      allowProcessPersonal: false
    }
  },
  validations: {
    buyer: {
      name: {
        required,
        textFieldValid
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        phoneValid
      }
    },
    allowProcessPersonal: {
      checked (val) {
        return val
      }
    },
    delivery: {
      date: {
        required (value) {
          if (!this.deliveryOn) {
            return true
          }
          if (!this.selfDelivery) {
            if (Array.isArray(value)) return !!value.length
            return value === undefined || value === null
              ? false
              : !!String(value).length
          } else {
            return true
          }
        }
      },
      address: {
        required (value) {
          if (!this.deliveryOn) {
            return true
          }
          if (!this.selfDelivery) {
            if (Array.isArray(value)) return !!value.length
            return value === undefined || value === null
              ? false
              : !!String(value).length
          } else {
            return true
          }
        }
      },
      addressApartment: {
        required (value) {
          if (!this.deliveryOn) {
            return true
          }
          if (!this.selfDelivery) {
            if (Array.isArray(value)) return !!value.length
            return value === undefined || value === null
              ? false
              : !!String(value).length
          } else {
            return true
          }
        }
      }
    },
    recipient: {
      name: {
        required (value) {
          return required(value) || this.delivery.toBuyer === true
        }
      },
      phone: {
        required (value) {
          return (required(value) && phoneValid(value)) || this.delivery.toBuyer === true
        }
      }
    },
    order: ['buyer', 'delivery', 'recipient', 'allowProcessPersonal']
  },
  components: {
    ContentLayout,
    MaskedInput,
    Datepicker,
    AddressSuggestions
  },
  computed: {
    datepickerDisabled () {
      const d = new Date()
      const n = d.getHours()
      const oFDates = [
        new Date(2023, 0, 1)
      ]
      if (n >= 20) {
        return {
          dates: oFDates,
          to: new Date(d.setDate(d.getDate() + 1))
        }
      }
      return {
        dates: oFDates,
        to: d
      }
    },
    minCost () {
      return this.currentCityObject.minRealCost
    },
    maxCost () {
      return this.currentCityObject.maxRealCost
    },
    currentCityObject () {
      return this.cities.find((c) => c.id === this.cityId)
    },
    city () {
      const city = this.cities.find((c) => c.id === this.cityId)
      return city && city.title ? city.title : ''
    },
    cards () {
      return this.cardsByCity[this.cityId]
    },
    selfDelivery () {
      return this.deliveryOn === false || this.subTotal < this.lowDeliveryLimit
    },
    openCard () {
      if (this.cards) {
        const cardId = Object.keys(this.cards).find(id => this.cards[id].openAmount)
        const openCard = this.cards[cardId]
        const oldOpenCard = this.oldOrder && this.oldOrder.items
          ? this.oldOrder.items.find(item => parseInt(item.id, 10) === openCard.id)
          : undefined
        return {
          ...openCard,
          amount: oldOpenCard ? oldOpenCard.amount : null
        }
      } else {
        return {}
      }
    },
    paidDelivery () {
      return this.subTotal < this.deliveryLimit && this.subTotal >= this.lowDeliveryLimit
    },
    postcardsTotal () {
      return this.postcard.qty * this.postcard.cost
    },
    subTotal () {
      return Object.keys(this.result).reduce((sum, id) => sum + this.cards[id].amount * this.result[id], 0) + this.openCardAmount * this.result[this.openCard.id] + this.postcardsTotal
    },
    total () {
      const result = this.deliveryOn && this.paidDelivery && this.subTotal > 0 ? this.subTotal + this.delivery.cost : this.subTotal
      if (this.isMobile) this.$emit('changePadding', result)
      return result
    }
  },
  created () {
    this.localLoading = true
    axios.get(`${apiUrl}/cards`)
      .then(({ data }) => {
        this.cities = data.cities
        this.specials = data.allSpecials
        this.postcards = data.postcards
        this.cardsByCity = data.cardsByCity
        this.postcard.cost = 49
        this.oldOrder = this.$localStorage.get('order')
        if (this.oldOrder && this.oldOrder.type === 'real') {
          const newCity = this.$localStorage.get('new_city')
          if (newCity) {
            this.changeCity(newCity)
            this.oldOrder.items.splice(0)
            this.$localStorage.remove('order')
          } else {
            this.changeCity(this.oldOrder.cityId)
          }
          this.delivery = this.oldOrder.delivery
          if (!this.delivery.toBuyer && this.oldOrder.recipient) {
            this.recipient = this.oldOrder.recipient
            if (this.recipient.phone[0] === '3') {
              this.recipient.phone = this.recipient.phone.replace(/\D/g, '').slice(3)
            }
          }
          this.buyer = this.oldOrder.buyer
          if (this.buyer.phone[0] === '3') {
            this.buyer.phone = this.buyer.phone.replace(/\D/g, '').slice(3)
          }
          this.oldOrder.items.forEach(order => {
            this.result[order.id] = order.qty
          })
          this.$localStorage.remove('new_city')
          this.$localStorage.remove('order')
        }
      })
      .finally(() => {
        this.localLoading = false
      })
    window.addEventListener('resize', this.setIsMobile)
    this.setIsMobile()
  },
  methods: {
    setIsMobile () {
      this.isMobile = window.innerWidth < 1024
      this.$emit('changePadding', this.isMobile && this.total)
    },
    changeCity (e) {
      this.cityId = e
      if (this.cards) {
        const result = {}
        Object.keys(this.cards).forEach(id => {
          result[id] = 0
        })
        this.result = Object.assign({}, this.result, result)
      }
      const city = this.cities.find(city => city.id === this.cityId)
      if (city) {
        // this.deliveryLimit = city.freeDeliveryLimit
        this.delivery.cost = city.deliveryCost
      }
      this.$nextTick(() => {
        this.$v.buyer.phone.$reset()
        this.$v.recipient.phone.$reset()
        // this.delivery.date = ''
      })
    },
    askChangeCity (cityId) {
      if (this.cityId && this.cityId !== cityId) {
        this.saveOrder()
        this.$localStorage.set('new_city', cityId)
        this.$router.push({ name: 'ModalCity', query: { city: this.cities.find(city => city.id === cityId).title } })
      } else {
        this.changeCity(cityId)
      }
    },
    addCard (id) {
      this.result[id]++
    },
    addOpenCard () {
      if (this.openCard.amount >= this.minCost && this.openCard.amount <= this.maxCost) {
        this.addCard(this.openCard.id)
      }
    },
    checkOpenCard (id) {
      this.incorrectFreeAmount = null
      if (this.openCard.amount > this.maxCost) {
        this.openCard.amount = this.maxCost
        this.incorrectFreeAmount = 'max'
      } else if (this.openCard.amount < this.minCost) {
        this.openCard.amount = this.minCost
        this.incorrectFreeAmount = 'min'
      }
      this.openCardAmount = this.openCard.amount
    },
    cleanPhone (value) {
      return value.replace(/\D/g, '').slice(1)
    },
    removeCard (id) {
      if (this.result[id] > 0) this.result[id]--
    },
    getCard (id) {
      return parseInt(id, 10) === parseInt(this.openCard.id, 10) ? this.openCard : this.cards[id]
    },
    addPostCard () {
      this.showPostCards = true
    },
    postcardsInc () {
      if (this.postcard.qty < 10 && (this.postcard.id || this.postcard.id === 0)) this.postcard.qty++
    },
    postcardsDec () {
      if (this.postcard.qty > 1) {
        this.postcard.qty--
      } else {
        this.postcard.qty--
        this.showPostCards = false
      }
    },
    extractOrder () {
      if (typeof this.delivery.date !== 'string') {
        const x = this.delivery.date
        const hoursDiff = x.getHours() - x.getTimezoneOffset() / 60
        const minutesDiff = (x.getHours() - x.getTimezoneOffset()) % 60
        x.setHours(hoursDiff)
        x.setMinutes(minutesDiff)
      }
      return {
        type: 'real',
        cityId: this.cityId,
        // postcard: this.postcard,
        buyer: this.buyer,
        recipient: this.recipient,
        delivery: this.delivery,
        paidDelivery: this.paidDelivery,
        items: Object.keys(this.result).filter(id => this.result[id]).map(id => {
          return {
            id,
            qty: this.result[id],
            amount: this.getCard(id).amount,
            specialDesign: this.getCard(id).specialDesign
          }
        }),
        total: this.total
      }
    },
    saveOrder (key = 'order') {
      const order = JSON.parse(JSON.stringify(this.extractOrder()))
      order.recipient.phone = order.recipient.phone.replace(/\D/g, '')
      order.buyer.phone = order.buyer.phone.replace(/\D/g, '')
      order.delivery.include = this.deliveryOn
      this.$localStorage.set(key, order)
      return order
    },
    sendOrder () {
      this.$v.order.$touch()
      if (this.delivery.toBuyer) {
        this.$v.order.recipient.phone.$reset()
        this.$v.order.recipient.$reset()
      }
      if (!this.$v.order.$error && this.addressIsCorrect) {
        this.pending = true
        const order = this.saveOrder()
        order.delivery.include = this.deliveryOn
        delete order.delivery.cost
        delete order.paidDelivery
        delete order.type
        delete order.total
        delete order.recipient
        if (!this.delivery.toBuyer) {
          order.recipient = JSON.parse(JSON.stringify(this.recipient))
          order.recipient.phone = order.recipient.phone.replace(/\D/g, '')
        }
        order.sendReceiptBySms = this.sendReceiptBySms
        axios.post(`${apiUrl}/order/real`, order)
          .then(({ data }) => {
            this.$localStorage.set('orderId', data.orderId)
            window.location.replace(data.redirect)
          })
          .catch(({ response }) => {
            this.pending = false
            if (response.status === 500) {
              this.$router.push({ name: 'ModalError', query: { type: 1 } })
            }
          })
      } else {
        this.scrollToFirtsInvalid()
      }
    },
    scrollToFirtsInvalid () {
      this.$nextTick(function () {
        window.scrollTo({ top: getTopPosition(document.querySelectorAll('.invalid')[0]), behavior: 'smooth' })
      })
    },
    onSumKeyPress (e) {
      if (e.key === '.' || e.key === ',') {
        e.preventDefault()
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setIsMobile)
  },
  watch: {
    'delivery.toBuyer' () {
      if (this.delivery.toBuyer) {
        this.$v.recipient.phone.$reset()
      }
    },
    deliveryOn (val) {
      if (!this.deliveryOn) {
        this.delivery.date = ''
      }
      this.delivery.include = val
    }
  }
}
</script>

<style src="@/components/Cards.css" scoped/>
